import { object, string, number, bool, setLocale, date } from "yup";
import { es } from "yup-locales";

setLocale(es);

export const paymentScheme = object({
  // METHOD PAYMENT
  payment_type: string().required().label("Tipo de pago"),

  // DATA USER
  customer_document_type: object().required().label("Tipo de documento"),
  possible_customer_document_type: object()
    .required()
    .label("Tipo de documento"),

  customer_document_number: string()
    .required()
    .matches(/[0-9]/, "Solo números")
    .label("N° Documento"),

  possible_customer_document_number: string()
    .required()
    .matches(/[0-9]/, "Solo números")
    .label("N° Documento"),

  customer_firstname: string()
    .required()
    .min(2, "No puede ser menor a 2 caracteres")
    .max(20, "No puede ser mayor a 20 caracteres")
    .matches(/^[a-zA-Z\s]*$/, "No puede tener caracteres especiales")
    .label("Primer Nombre"),

  possible_customer_firstname: string()
    .required()
    .min(2, "No puede ser menor a 2 caracteres")
    .max(20, "No puede ser mayor a 20 caracteres")
    .matches(/^[a-zA-Z\s]*$/, "No puede tener caracteres especiales")
    .label("Primer Nombre"),

  possible_customer_firstname: string()
    .required()
    .min(2, "No puede ser menor a 2 caracteres")
    .max(20, "No puede ser mayor a 20 caracteres")
    .matches(/^[a-zA-Z\s]*$/, "No puede tener caracteres especiales")
    .label("Primer Nombre"),

  customer_lastname: string()
    .required()
    .min(2, "No puede ser menor a 2 caracteres")
    .max(20, "No puede ser mayor a 20 caracteres")
    .matches(/^[a-zA-Z\s]*$/, "No puede tener caracteres especiales")
    .label("Primer Apellido"),

  possible_customer_lastname: string()
    .required()
    .min(2, "No puede ser menor a 2 caracteres")
    .max(20, "No puede ser mayor a 20 caracteres")
    .matches(/^[a-zA-Z\s]*$/, "No puede tener caracteres especiales")
    .label("Primer Apellido"),


  customer_email: string()
    .required()
    .min(5, "No puede ser menor a 5 caracteres")
    .max(40, "No puede ser mayor a 40 caracteres")
    .matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, "El correo no es válido")
    .label("Correo"),

  customer_number_phone: string()
    .required()
    .min(10)
    .max(15)
    .matches(
      /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
      "El numero no es válido"
    )
    .label("Telefono"),

  // VENUE
  customer_venue: object().required().label("Sede"),
  customer_city: object().required().label("Ciudad"),

  // DATE
  execute_at: date(),

  // CARD
  card_number: number()
    .when("payment_type", { is: "card", then: (scheme) => scheme.required() })
    .label("Número de tarjeta"),
  card_expiration_date: string()
    .when("payment_type", { is: "card", then: (scheme) => scheme.required() })
    .max(5)
    .label("F. Vencimiento"),
  card_cvv: string()
    .when("payment_type", { is: "card", then: (scheme) => scheme.required() })
    .label("Número de tarjeta"),

  // PSE
  bank: object()
    .when("payment_type", { is: "pse", then: (scheme) => scheme.required() })
    .label("Banco"),
  account_number: number()
    .when("payment_type", { is: "pse", then: (scheme) => scheme.required() })
    .label("Número de cuenta"),
  account_type: object()
    .when("payment_type", { is: "pse", then: (scheme) => scheme.required() })
    .label("Tipo de cuenta"),
  terms_of_use: bool()
    .oneOf([true], "El campo debe estar marcado")
    .required()
    .label("Términos y condiciones"),
});
